<template>
  <div class="page-register">
    <div class="title">手机号码快捷注册</div>
    <!-- 注册表单 -->
    <van-form @submit="onSubmit" @failed="onFailed" ref="fromItemRef">
      <!-- 用户名手机号码 -->
      <van-field
        v-model="fromItem.mobile"
        placeholder="请输入您的手机号码"
        left-icon="phone-o"
        type="tel"
        :error-message="phoneError"
        :style="{'margin-bottom': phoneError ? '6px':'30px' }"
        @input="clearError1"
        @blur="phoneBlue"
        :rules="[{ required: true, pattern: phoneReg, message: phoneError }]"
      />
      <!-- 验证码 -->
      <van-field
        v-model="fromItem.code"
        center
        placeholder="请输入验证码"
        type="digit"
        :error-message="codeError"
        :style="{'margin-bottom': codeError ? '38px':'62px' }"
        @input="clearError2"
        @blur="codeBlur"
        :rules="[{ required: true, pattern: codeReg, message: codeError }]"
      >
        <van-button
          :disabled="isDisabled"
          class="codeBtn"
          type="info"
          plain
          slot="button"
          size="small"
          native-type="button"
          @click="checkMobileExists"
        >
          {{
          registerCountDown.count
          ? registerCountDown.count + '秒后重试'
          : '获取验证码'
          }}
        </van-button>
      </van-field>
      <van-button round block type="info" native-type="submit">注册</van-button>
    </van-form>
    <!-- 公共组件 底部 -->
    <bt_logo></bt_logo>
    <drag-verify ref="slideblock" :value.sync="isShowVerify" @success="onSuccess"></drag-verify>
  </div>
</template>
<script>
// 引入公共组件
import { getStoreNameIsAvailable, getAvailableStoreLinks } from '@/api/store'
import btLogo from '@/components/btLogo'
import DragVerify from '@/components/drag-verify'
import store from '@/vuex/store'
import { getPlatFormCode, formatSeconds } from '@/libs/util'
import { Toast, Dialog } from 'vant'
export default {
  data() {
    return {
      isShowVerify: false,
      fromItem: {
        mobile: '', // 手机号码
        code: '', // 验证码
        pass_word: '', // 设置密码
        address: {
          province_id: '',
          province_name: '',
          city_id: '',
          city_name: '',
          area_id: '',
          area_name: '',
        },
        adVal: [],
        channel: 12, //来源渠道
        promotes_id: '0', // 推广id
        referrer: '', // 推广来源地址
      },
      registerCountDown: {
        count: '', // 验证码计时
        timer: null, // 定时器
      },
      msgError: '', // 店铺名称
      phoneError: '', // 手机验证
      codeError: '', // 验证码验证
      phoneReg: /^1[3456789]\d{9}$/, // 手机号正则校验
      codeReg: /^[a-zA-Z0-9]{4}$/, // 验证码正则校验
      icon: 'closed-eye',
      isDisabled: false,
      addressCode: '',
      isLogin: false, // 注册防重复
    }
  },
  async created() {
    // 获取平台信息
    let platformcode = getPlatFormCode()
    // 没有平台信息
    if (!platformcode) {
      store.dispatch('getPlatform').then((platform) => {})
    }
    // 获取省份列表
    await this.getCityList()
    this.getLocation() // 调用获取地理位置
    // 获取推广id和推广来源地址
    let paramsStr = window.location.search
    let arr = paramsStr.slice(1, paramsStr.length).split('&')
    if (paramsStr.indexOf('spid') != -1) {
      let resulve = []
      arr.forEach((item) => {
        resulve.push(item.split('='))
      })
      let res = []
      resulve.forEach((v, t) => {
        v.forEach((item) => {
          if (item == 'spid' && resulve[t][1] > 0) {
            this.fromItem.promotes_id = resulve[t][1]
          }
        })
      })
    } else {
      this.fromItem.promotes_id = '0'
    }
    if (paramsStr.indexOf('reffer') != -1) {
      let resulve = []
      arr.forEach((item) => {
        resulve.push(item.split('='))
      })
      let res = []
      resulve.forEach((v, t) => {
        v.forEach((item) => {
          if (item == 'reffer' && resulve[t][1] != 'undefined') {
            this.fromItem.referrer = resulve[t][1]
          }
        })
      })
    } else {
      this.fromItem.referrer = ''
    }
  },
  methods: {
    onSuccess(ticket) {
    },
    showCityListOn() {
      // 打开弹框
      this.showAddress = true
    },
     // 登录凭证
    // test() {
    //   this.$cookie.set(
    //     'token',
    //     'HULfzGVmC6aKcnGtDziLvUR6OpuGKyie%2b4a9rHhMHEOmnfkINapGjSSNlo%2bcYKUkxyccIvJzIjra9nZYXm51b%2fDFlZHYCsLupUNxn3rMkiMm5icxNjmpXGwgD9rZGW1LiY0Iuri%2fhaqbYPy1LGdmmjaBhDU6KgzpMiMOEaEEXRyuHH7eL%2f6KyFKNp3hd%2bSLG',
    //     {
    //       expires: 7
    //     }
    //   )
    //   this.$store.commit('tokenToVuex')
    //   this.getUserInfo()
    // },
    // 获取验证码
    checkMobileExists() {
      let _this = this
      if (_this.fromItem.mobile == '') {
        return Toast('请输入手机号码')
      }

      // 测试
      // return this.test()
      this.isDisabled = true
      _this.$api
        .checkMobileExists({
          mobile: _this.fromItem.mobile,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$api
              .sendCode({
                mobile: _this.fromItem.mobile,
                code_type: 5,
              })
              .then((res) => {
                if (res.code == '200') {
                  // _this.$Message.success('发送成功');
                  Toast.success('发送成功')
                } else {
                  // _this.$Message.error('发送失败');
                  Toast(res.msg)
                }
              })

            //  _this.phoneError = res.msg
            // 倒计时...
            // this.isDisabled = true
            const TIME_COUNT = 60
            _this.registerCountDown.count = TIME_COUNT

            // _this.registerCountDown.show = false;

            _this.registerCountDown.timer = setInterval(() => {
              if (
                _this.registerCountDown.count > 0 &&
                _this.registerCountDown.count <= TIME_COUNT
              ) {
                _this.registerCountDown.count--
              } else {
                // _this.registerCountDown.show = true;
                this.isDisabled = false
                _this.yzmType = true

                clearInterval(_this.registerCountDown.timer)

                _this.registerCountDown.timer = null
              }
            }, 1000)
          } else if (res.code == 201) {
            this.isDisabled = false
            _this.phoneError = ''
            return Dialog.confirm({
              title: '该手机号已被注册',
              message:
                '【推荐】使用电脑打开 panel.deiyoudian.com登录您的帐号即可上架商品做营销活动\n应用商店搜索 “得有店” APP下载客户端进行 管理店铺\n在使用过程中，有任何问题可联系专属客服一对 一为您解答',
              messageAlign: 'left',
              showCancelButton: false,
            })
          } else {
            this.isDisabled = false
            Toast(res.msg)
          }
        })
    },
    // 手机号验证
    phoneBlue(e) {
      let pR = /^1[3456789]\d{9}$/
      let _this = this
      if (e.target.value.trim() == '') {
        // Toast.fail('店铺名称不能为空')
        return (_this.phoneError = '手机号不能为空')
      }
      if (!pR.test(e.target.value)) {
        return (_this.phoneError = '请输入正确的手机号')
      }
      _this.$api
        .checkMobileExists({
          mobile: _this.fromItem.mobile,
        })
        .then((res) => {
          if (res.code !== 200) {
            Dialog.confirm({
              title: '该手机号已被注册',
              message:
                '【推荐】使用电脑打开 panel.deiyoudian.com登录您的帐号即可上架商品做营销活动\n应用商店搜索 “得有店” APP下载客户端进行 管理店铺\n在使用过程中，有任何问题可联系专属客服一对 一为您解答',
              messageAlign: 'left',
              showCancelButton: false,
            })
            return (_this.phoneError = res.msg)
          }
        })
    },
    // 验证码验证
    codeBlur(e) {
      let cR = /^[a-zA-Z0-9]{4}$/
      if (e.target.value.trim() == '') {
        return (this.codeError = '请输入验证码')
      }
      if (!cR.test(e.target.value)) {
        return (this.codeError = '验证码格式输入错误')
      }
    },
    // 触发验证
    onFailed(errorInfo) {
      // console.log('failed', errorInfo)
      this.onSubmit()
    },
    // 注册
    onSubmit(values) {
      let _this = this
      if (_this.fromItem.mobile == '') return Toast('手机号码不能为空')
      let pR = /^1[3456789]\d{9}$/
      if (!pR.test(_this.fromItem.mobile)) return (_this.phoneError = '请输入正确的手机号')
      if (_this.phoneError) {
        return Dialog.confirm({
          title: '该手机号已被注册',
          message:
            '【推荐】使用电脑打开 panel.deiyoudian.com登录您的帐号即可上架商品做营销活动\n应用商店搜索 “得有店” APP下载客户端进行 管理店铺\n在使用过程中，有任何问题可联系专属客服一对 一为您解答',
          messageAlign: 'left',
          showCancelButton: false,
        })
      }
      if (_this.fromItem.code == '') {
        return Toast('请输入验证码')
      }
      this.fromItem.pass_word = (this.fromItem.mobile + '').slice(5)
      if(this.fromItem.address.province_name == '') {
        let address = {
          province_name: '河南省',
          province_id: '56d99b86-0985-4aa6-bc73-2b95709a981e',
          city_name: '郑州市',
          city_id: '24917c6b-f5ef-41da-bf56-38581405b7df',
          area_name: '金水区',
          area_id: 'e17c505d-490b-41fd-9029-981f157a4aab'
        }
        this.fromItem.address = address
      }
      localStorage.setItem('addressData', JSON.stringify(_this.fromItem.address))
      if (!_this.isLogin) {
        _this.isLogin = true
        _this.$api.usersRegister(_this.fromItem).then((res) => {
          _this.isLogin = false
          if (res.code != 200) return Toast(res.msg)
          if (res.response.success) {
            _this.$cookie.set('token', res.response.token, { expires: 7 })
            _this.$store.commit('tokenToVuex')
            _this.getUserInfo()
          }
        })
      }
    },

    clearError1(e) {
      if (this.phoneError && e != '') {
        this.phoneError = ''
      }
    },
    clearError2(e) {
      if (this.codeError && e != '') {
        this.codeError = ''
      }
    },
    // 注册成功后获取用户信息
    getUserInfo(isRegister) {
      let _this = this
      // 获取用户信息
      this.$api.getUserInfo().then(function (res) {
        if (res.code != '200') {
          return Toast.fail('获取用户信息失败')
        }
        _this.$cookie.set('user', JSON.stringify(res.response), {
          expires: 7,
        })
        _this.$store.commit('userToVuex')
        if (res.response.has_password) {
          if (res.response.has_agent_address) {
            Toast.success('登录成功')
            _this.$router.push({
              name: 'beauty-create-store',
            })
          }
        }
      })
    },
    //得到所有的省市区列表
    async getCityList(provinceId) {
      return this.$api.getregions().then((res) => {
        if (res.code !== 200) {
          return Toast.fail('获取省市区列表失败')
        }
        let areaList = {
          province_list: {},
          city_list: {},
          county_list: {},
        }
        this.allAreaData = res.response
        this.allAreaData.provinces.forEach((val) => {
          areaList.province_list[
            val.unique
          ] = `${val.title}<i style='display:none;'>-${val.id}^</i>`
        }) // 省
        this.allAreaData.citys.forEach((val) => {
          areaList.city_list[
            val.unique
          ] = `${val.title}<i style='display:none;'>-${val.id}^</i>`
        }) // 市
        this.allAreaData.districts.forEach((val) => {
          areaList.county_list[
            val.unique
          ] = `${val.title}<i style='display:none;'>-${val.id}^</i>`
        }) // 区
        this.areaList = areaList
      })
    },
    /**获取地图定位*/
    getLocation() {
      const that = this
      let map = new AMap.Map('contaner')
      AMap.plugin('AMap.Geolocation', function () {
        // map.addControl(new AMap.Geolocation())
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：无穷大
          maximumAge: 0, //定位结果缓存0毫秒，默认：0
          convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: false, //显示定位按钮，默认：true
          buttonPosition: 'LB', //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: false, //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: false, //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        })
        map.addControl(geolocation)
        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', onComplete) // 用户允许使用当前地址
        AMap.event.addListener(geolocation, 'error', onError) // 用户拒绝
        // 用户允许获取当前位置
        function onComplete(data) {
          // data是具体的定位信息
          // 省
          that.province = data.addressComponent.province
          // 市
          that.city = data.addressComponent.city
          // 区
          that.district = data.addressComponent.district
          if (that.province != '' && that.city != '' && that.district != '') {
            if (that.allAreaData) {
              // 根据获取的省份筛选
              let p = that.allAreaData.provinces.filter(
                (item) => that.province == item.title
              )
              // 根据获取的市名筛选
              let c = that.allAreaData.citys.filter(
                (item) => that.city == item.title
              )
              // 根据获取的区名筛选
              let d = that.allAreaData.districts.filter(
                (item) => that.district == item.title
              )
              // 当前定位省市区的code
              that.codeP = p[0].unique
              that.codeC = c[0].unique
              that.codeD = d[0].unique
              // 选择城市名称
              that.fromItem.address.province_name = p[0].title
              that.fromItem.address.city_name = c[0].title
              that.fromItem.address.area_name = d[0].title
              // 选择城市id
              that.fromItem.address.province_id = p[0].id
              that.fromItem.address.city_id = c[0].id
              that.fromItem.address.area_id = d[0].id
              that.fromItem.adVal = [p[0].id, c[0].id, d[0].id]
              that.addressStr = [that.province, that.city, that.district].join(
                ' / '
              )
              that.addressCode = that.codeD
              // that.positionPCD = true
            }
            // })
          }
        }
        function onError(data) {
          // 定位出错
          console.log(data)
        }
      })
    },
  },
  components: {
    bt_logo: btLogo,
    DragVerify,
  },
}
</script>
<style lang="css" scoped>
.page-register {
  height: 100%;
  padding: 0 37px;
  box-sizing: border-box;
  overflow: hidden;
}
.title {
  margin: 140px 0 80px 0;
  font-size: 23px;
  color: #333;
}
.van-button--info {
  color: #fff;
  background-color: #3d6eff;
  border: 0.02667rem solid #3d6eff;
}
.codeBtn {
  border: none;
  color: #3d6eff !important;
  background-color: transparent;
}
.van-field {
  margin-bottom: 30px;
  padding: 5px 0;
}
/* icon 图标样式 */
.van-icon {
  margin-right: 5px;
}

.van-form {
  position: relative;
  margin-bottom: 130px;
}
.van-field__error-message {
  font-size: 16px;
}
.van-cell--required::before {
  left: 5px;
  top: 8px;
  font-size: 20px;
}
</style>
